import { __awaiter, __generator } from "tslib";
import { getFetchEntityUrl } from '../utilities/get-fetch-entity-url';
import { fetchGetProductCatalogue } from './fetch-get-product-catalogue';
/**
 * @internal
 */
export var fetchEntity = function (entityId, productType, includeType) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = getFetchEntityUrl(entityId, productType, includeType);
                return [4 /*yield*/, fetchGetProductCatalogue(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
